import fetchApi from "ui-io/fetch-api";
import { RawTaskIO } from "ui-io/task-io";
import { makeTaskT } from "ui-io/task-io/task-t";

export const TASKS_QUERY_FILTER = "TASKS_QUERY_FILTER";

export const taskQuery = ({ taskId }: { taskId: string | undefined}) => ({
  queryKey: [TASKS_QUERY_FILTER, taskId],
  queryFn: () =>
    fetchApi({
      service: "admin-service",
      method: "GET",
      pathname: `/tasks/${taskId}`,
      codec: RawTaskIO,
    }).then((rawTask) => makeTaskT(rawTask)),
});
